import { render, staticRenderFns } from "./EditMyAccount.vue?vue&type=template&id=6180a6f4&scoped=true&"
import script from "./EditMyAccount.vue?vue&type=script&lang=ts&"
export * from "./EditMyAccount.vue?vue&type=script&lang=ts&"
import style0 from "./EditMyAccount.vue?vue&type=style&index=0&id=6180a6f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6180a6f4",
  null
  
)

export default component.exports